import { createUiKit } from '@barbanet/ui-kit'

import '@barbanet/ui-kit/styles'

export default createUiKit({
	theme: {
		default: {
			name: 'curator'
		}
	},
	defaults: {
		BInput: {
			variant: 'outline',
			clearable: true
		},
		BSnackbar: {
			position: 'top-center',
			closable: true
		},
		BModal: {
			maxWidth: 280
		}
	}
})
